module.exports = __webpack_public_path__ + "static/media/view route.426d4c72.svg";